module.exports = __webpack_public_path__ + "img/Tenets.60ffab6f.png";